/**
 * @param {import('@tidal/tracking').AmplitudeConfigInterface} config
 * @param {import('@tidal/tracking').AmplitudeRequestInterface} req
 * @returns {string}
 */
function buildConfig(config, req) {
    /** @type {Partial<import('@tidal/tracking').AmplitudeConfigInterface>} */
    const configCopy = Object.assign({}, config);
    delete configCopy.enable;
    delete configCopy.amplitudeKey;

    if (configCopy.includeUtm === null || configCopy.includeUtm === undefined) {
        configCopy.includeUtm = true;
    }
    if (configCopy.includeReferrer === null || configCopy.includeReferrer === undefined) {
        configCopy.includeReferrer = true;
    }
    if (configCopy.saveParamsReferrerOncePerSession === null || configCopy.saveParamsReferrerOncePerSession === undefined) {
        configCopy.saveParamsReferrerOncePerSession = true;
    }

    if (req.query.amplitudeDeviceId || req.body.amplitudeDeviceId) {
        // store the amplitude device id in session
        req.session.amplitudeDeviceId = req.query.amplitudeDeviceId ? req.query.amplitudeDeviceId :
            req.body.amplitudeDeviceId;
        // set it in vue so it gets rendered
        configCopy.deviceId = req.session.amplitudeDeviceId;
    } else if (req.session && req.session.amplitudeDeviceId) {
        configCopy.deviceId = req.session.amplitudeDeviceId;
    }
    return JSON.stringify(configCopy);
}

/**
 * @param {import('@tidal/tracking').AmplitudeConfigInterface} config
 */
const tidalAmplitudeMiddleware = (config) => (
    /**
    * @param {import('@tidal/tracking').AmplitudeRequestInterface} req
    * @param {import('express').Response} res
    * @param {import('express').NextFunction} next
    */
    (req, res, next) => {
        const amplitudeKey = config.amplitudeKey;
        const amplitudeSrc = 'https://cdn.amplitude.com/libs/amplitude-4.5.0-min.gz.js';

        const srcStart = `<script type="text/javascript">(function(e, t) {
            var n = e.amplitude || { _q: [], _iq: {} }; var r = t.createElement("script");
            r.type = "text/javascript";
            r.async = true;
            r.src = "${amplitudeSrc}";
            r.onerror = function() {n.amplitudeInitialize="failed";window.dispatchEvent(new Event("amplitudeInitializeFailed"));};
            r.onload = function() {if (e.amplitude.runQueuedFunctions) { e.amplitude.runQueuedFunctions() } else {window.dispatchEvent(new Event("amplitudeInitializeFailed"));n.amplitudeInitialize="failed"; console.log("[Amplitude] Error: could not load SDK") } };
            var i = t.getElementsByTagName("script")[0];
            i.parentNode.insertBefore(r, i);

            function s(e, t) { e.prototype[t] = function() { this._q.push([t].concat(Array.prototype.slice.call(arguments, 0))); return this } } var o = function() { this._q = []; return this }; var a = ["add", "append", "clearAll", "prepend", "set", "setOnce", "unset"]; for (var u = 0; u < a.length; u++) { s(o, a[u]) } n.Identify = o; var c = function() { this._q = []; return this }; var l = ["setProductId", "setQuantity", "setPrice", "setRevenueType", "setEventProperties"]; for (var p = 0; p < l.length; p++) { s(c, l[p]) } n.Revenue = c; var d = ["init", "logEvent", "logRevenue", "setUserId", "setUserProperties", "setOptOut", "setVersionName", "setDomain", "setDeviceId", "setGlobalUserProperties", "identify", "clearUserProperties", "setGroup", "logRevenueV2", "regenerateDeviceId", "logEventWithTimestamp", "logEventWithGroups", "setSessionId"];

            function v(e) {
                function t(t) { e[t] = function() { e._q.push([t].concat(Array.prototype.slice.call(arguments, 0))) } } for (var n = 0; n < d.length; n++) { t(d[n]) }
            } v(n);
            n.getInstance = function(e) {
                e = (!e || e.length === 0 ? "$default_instance" : e).toLowerCase(); if (!n._iq.hasOwnProperty(e)) {
                    n._iq[e] = { _q: [] };
                    v(n._iq[e])
                } return n._iq[e]
            };
            e.amplitude = n
        })(window, document);`;
        const configString = buildConfig(config, req);
        if (config.enable) {
            let userId = null;
            // if we have a user in the session add the user id in too
            if (req.session && req.session.passport && req.session.passport.user && req.session.passport.user.profile) {
                userId = req.session.passport.user.profile.id ? req.session.passport.user.profile.id : req.session.passport.user.profile.userId;
            } else if (req.session && req.session.canalDigitalUser) {
                userId = req.session.canalDigitalUser.id;
            } else if (req.session && req.session.sheerid && req.session.sheerid.userId) {
                userId = req.session.sheerid.userId;
            } else if (req.session && req.session.user && (req.session.user.id || req.session.user.userId)) {
                userId = req.session.user.id ? req.session.user.id : req.session.user.userId;
            } else if (req.session && req.session.userId) {
                userId = req.session.userId;
            }

            req.vueOptions.head.scripts.push({
                srcContents: `${srcStart}
                try {window.amplitude.amplitudeInitialize="running";} catch(e) {}
                amplitude.init("${amplitudeKey}", ${userId ? '\'' + userId + '\'' : null}, ${configString}, function(){
                    window.dispatchEvent(new Event("amplitudeInitializeSuccess"));
                    window.amplitude.amplitudeInitialize="done";
                });</script>`,
            });

            if (config.preload) {
                req.vueOptions.head.scripts.push({
                    srcContents: `<link rel="preload" href="${amplitudeSrc}" as="script" nopush >`,
                });
            }
        } else {
            req.vueOptions.head.scripts.push({
                srcContents: '<script type="text/javascript">try{window.amplitude.amplitudeInitialize="failed";window.amplitude=null;var amplitude=null;}catch(e){}</script>',
            });
        }
        next();
    }
);
module.exports.init = tidalAmplitudeMiddleware;
